"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.addSpan = exports.deleteAccount = exports.handleSignedOutUser = exports.handleSignedInUser = void 0;
function handleSignedInUser(user) {
    document.getElementById('user-signed-in').style.display = 'inline';
    document.getElementById('name').textContent = user.displayName;
    document.getElementById('email').textContent = user.email;
}
exports.handleSignedInUser = handleSignedInUser;
function handleSignedOutUser() {
    document.getElementById('user-signed-in').style.display = 'none';
    window.location.replace('.');
}
exports.handleSignedOutUser = handleSignedOutUser;
function deleteAccount() {
    if (window.confirm('Are you sure you want to delete your account?')) {
        firebase.auth().currentUser.delete().catch(function (error) {
            if (error.code === 'auth/requires-recent-login') {
                firebase.auth().signOut().then(function () {
                    setTimeout(function () {
                        alert('Please sign in again to delete your account.');
                    }, 1);
                });
            }
        });
    }
}
exports.deleteAccount = deleteAccount;
function addSpan() {
    var span = document.createElement('span');
    var inner = '<span id="user-signed-in" class="hidden">';
    inner += '<span id="user-info"><span id="name"></span>';
    inner += '(<span id="email"></span>)<div>';
    inner += '<span><button id="sign-out">Sign Out</button></span>';
    inner += '<span><button id="delete-account">Delete account</button></span>';
    inner += '</div></span></span>';
    span.innerHTML = inner;
    document.body.appendChild(span);
    document.getElementById('sign-out').addEventListener('click', function () {
        firebase.auth().signOut();
    });
    document.getElementById('delete-account').addEventListener('click', function () {
        deleteAccount();
    });
}
exports.addSpan = addSpan;
function init() {
    addSpan();
    firebase.auth().onAuthStateChanged(function (user) {
        user ? handleSignedInUser(user) : handleSignedOutUser();
    });
}
exports.init = init;
